export type InventaireViewMode = 'liste' | 'card-grid' | 'card-full';

export const INVENTAIRE_VIEW_MODE_STORAGE_KEY = 'inventwee-inventaire-view-mode';

export function parseInventaireViewMode(value: string | null): InventaireViewMode | null {
  if (value === 'liste' || value === 'card-grid' || value === 'card-full') {
    return value;
  }
  if (value === 'card') {
    return 'card-grid';
  }
  return null;
}

export function getDefaultInventaireViewMode(): InventaireViewMode {
  if (typeof window !== 'undefined' && window.matchMedia('(min-width: 768px)').matches) {
    return 'liste';
  }
  return 'card-grid';
}

export function getInventaireGridClassName(viewMode: InventaireViewMode): string {
  switch (viewMode) {
    case 'card-full':
      return 'grid grid-cols-1 gap-4';
    case 'card-grid':
      return 'grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4';
    case 'liste':
    default:
      return 'space-y-3';
  }
}
